import config from '@/settings.js'
import Cookies from 'js-cookie'
// Cookies.set('name', 'value', { path: '' })
// Cookies.get('name') // => 'value'
// Cookies.remove('name', { path: '' })

export const localSave = (key, value) => {
  //localStorage.setItem(key, value)
  Cookies.set(key, value)
}

export const localRead = (key) => {
  // if(!(localStorage.getItem(key) || '')){
  //     localSave('local', config.lang);
  //     return config.lang
  // }
  // return localStorage.getItem(key) || ''

  if(!(Cookies.get(key) || '')){
    // localSave('local', config.lang);
    return config.lang
  }
  return Cookies.get(key) || ''
}


// WEBPACK FOOTER //
// ./src/store/lang.js